export const FREE_TRIAL_DURATION = 14; // days
